import * as amo from "../api/amo";
import { call, fork, put, take, takeLatest } from "redux-saga/effects";
import { NavLink, useNavigate } from "react-router-dom";
import amoActions from "../slices/amoSlice";
import { ErrorLogic } from "../../components/hooks/authFunc";

//아모 부리토 월렛주소 등록
function* requestFetchWalletAddressAdd(payload) {
  const params = payload.payload;
  const { response, err } = yield call(amo.requestWalletAddressAdd, params);
  if (response) {
    yield put(amoActions.actions.fetchWalletAddressAddSuccess(response));
  } else {
    yield put(amoActions.actions.fetchWalletAddressAddFailure(err));
  }
}

//아모 교환 페이지 정보
function* requestFetchSwapInfo(payload) {
  const params = payload.payload;
  const { response, err } = yield call(amo.requestSwapInfo, params);
  if (response) {
    yield put(amoActions.actions.fetchSwapInfoSuccess(response));
  } else {
    yield put(amoActions.actions.fetchSwapInfoFailure(err));
    yield ErrorLogic(err.response);
  }
}

//뮤포인트 -> 아모코인 교환
function* requestFetchSwapMupToAmo(payload) {
  const params = payload.payload;
  const { response, err } = yield call(amo.requestSwapMupToAmo, params);
  if (response) {
    yield put(amoActions.actions.fetchSwapMupToAmoSuccess(response));
  } else {
    yield put(amoActions.actions.fetchSwapMupToAmoFailure(err));
  }
}

//아모 거래내역
function* requestFetchAmoHistory(payload) {
  const params = payload.payload;
  const { response, err } = yield call(amo.requestAmoHistory, params);
  if (response) {
    yield put(amoActions.actions.fetchAmoHistorySuccess(response));
  } else {
    yield put(amoActions.actions.fetchAmoHistoryFailure(err));
    yield ErrorLogic(err.response);
  }
}

// 아모 임시 입금 주소
function* requestFetchTemporaryWalletAddr(payload) {
  const params = payload.payload;
  const { response, err } = yield call(amo.requestTemporaryWalletAddr, params);
  if (response) {
    yield put(amoActions.actions.fetchTemporaryWalletAddrSuccess(response));
  } else {
    yield put(amoActions.actions.fetchTemporaryWalletAddrFailure(err));
    yield ErrorLogic(err.response);
  }
}

// 아모코인 일회용주소 입금 확인하기
function* requestFetchSwapConfirm(payload) {
  const params = payload.payload;
  const { response, err } = yield call(amo.requestSwapConfirm, params);
  if (response) {
    yield put(amoActions.actions.fetchSwapConfirmSuccess(response));
  } else {
    yield put(amoActions.actions.fetchSwapConfirmFailure(err));
    yield ErrorLogic(err.response);
  }
}

// 아모코인 -> 뮤포인트 교환
function* requestFetchSwapAmoToMup(payload) {
  const params = payload.payload;
  const { response, err } = yield call(amo.requestSwapAmoToMup, params);
  if (response) {
    yield put(amoActions.actions.fetchSwapAmoToMupSuccess(response));
  } else {
    yield put(amoActions.actions.fetchSwapAmoToMupFailure(err));
  }
}
export default function* watchAmo() {
  yield takeLatest(
    amoActions.actions.fetchWalletAddressAdd,
    requestFetchWalletAddressAdd
  );
  yield takeLatest(amoActions.actions.fetchSwapInfo, requestFetchSwapInfo);
  yield takeLatest(
    amoActions.actions.fetchSwapMupToAmo,
    requestFetchSwapMupToAmo
  );
  yield takeLatest(amoActions.actions.fetchAmoHistory, requestFetchAmoHistory);
  yield takeLatest(
    amoActions.actions.fetchTemporaryWalletAddr,
    requestFetchTemporaryWalletAddr
  );
  yield takeLatest(
    amoActions.actions.fetchSwapConfirm,
    requestFetchSwapConfirm
  );
  yield takeLatest(
    amoActions.actions.fetchSwapAmoToMup,
    requestFetchSwapAmoToMup
  );
}
